import { PureComponent, PropsWithChildren } from "react";

export default class SpellsFilterAdvancedFilterLabel extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-spells-filter__adv-filter-label">
        {this.props.children}
      </div>
    );
  }
}
